module.exports = __webpack_public_path__ + "img/m.49ed247a.jpg";